import { useCallback, useMemo } from 'react';
import { useIterableFormHook } from '../../../hooks/useIterableFormListHook/useIterableFormHook';
import { FormOptions } from '../../../hooks/useFormHookFactory/useFormHookFactory';
import { MissingErrorComponent } from '../../../uiComponent/MissingErrorComponent/MissingErrorComponent';
import { ClinicalGoalItem } from '../../../uc-api-sdk';

export const useClinicalGoalForm = (options?: FormOptions) => {
  const factory = useIterableFormHook('clinicalGoals', {
    clinicalGoalName: {
      name: 'clinicalGoalName',
      label: '',
    },
    goalStatus: {
      name: 'goalStatus',
      label: 'Status',
    },
    updatedDate: {
      name: 'updatedDate',
      label: '',
    },
    condition: {
      name: 'condition',
      label: '',
    },
    isManualInput: {
      name: 'isManualInput',
      label: '',
    },
    customCategory: {
      name: 'customCategory',
      label: '',
    },
    customContent: {
      name: 'customContent',
      label: '',
    }
  }, options);

  const makeClinicalGoalRules = useCallback((selectedGoals?: ClinicalGoalItem[]) => [
    {
      message: <MissingErrorComponent />,
      required: !selectedGoals?.length,
    }
  ], []);

  const response = useMemo(() => ({
    ...factory,
    makeClinicalGoalRules
  }), [factory]);

  return response;
};
